import React, { Component } from 'react'
import { Context } from '../../Context'
import logo from '../../../assets/rhomberg-logo.svg'
import Mouse from '../../../assets/mouse.png'
import AnimatedLogo from '../../Libs/AnimatedLogo'
import AnimatedBackgroundImage from '../../Libs/AnimatedBackgroundImage'
import AnimatedMenu from '../../Libs/AnimatedMenu'

let items = [
    {
        id: 1,
        title: 'Leistungen',
        description: null,
        data: [
            {
                list: ['Sanieren', 'Umbauen', 'Revitalisieren', 'Modernisieren'],
            },
        ],
    },
    {
        id: 2,
        title: 'Gewerbe- \r\nkunden',
        description: null,
        data: [
            {
                header: 'Von Rhomberg Bau:',
                list: [
                    'Energie- und Sanierungsberatung',
                    'Analyse der Umnutzungsmöglichkeiten',
                    'Planung und Konzeption',
                    'Wirtschaftlichkeitsberechnungen (Kosten, Folgekosten)',
                    'Schlüsselfertige Ausführung der Um-, An- und Ausbauten',
                ],
            },
            {
                header: 'Für Ihr gewerbliches Bauprojekt',
                list: ['Generalunternehmerleistungen „Alles aus einer Hand“', 'Zeitliche Entlastung des Bauherrn', 'Termintreue, Kostentreue und Kostentransparenz', 'Facility Management'],
            },
        ],
    },
    {
        id: 3,
        title: 'Privatkunden',
        description: null,
        data: [
            {
                header: 'Von Rhomberg Bau:',
                list: [
                    'Erarbeiten von Umgestaltungs- und Umnutzungsmöglichkeiten',
                    'Fundierte Energie- und Sanierungsberatung',
                    'Umfassende Umbau- und Sanierungskonzepte',
                    'Finanzierungs- und Förderberatung',
                    'Zeitliche Entlastung des Bauherrn',
                ],
            },
            {
                header: 'Für Ihr privates Bauprojekt:',
                list: [
                    'Generalunternehmerleistungen „Alles aus einer Hand“',
                    'Reduktion der Energie- und Betriebskosten',
                    'Termintreue, Kostentreue und Kostentransparenz',
                    'Vorausschauende Planung für jeden Lebensabschnitt',
                ],
            },
        ],
    },
    {
        id: 4,
        title: 'Wohnanlagen',
        description: null,
        data: [
            {
                header: 'Von Rhomberg Bau:',
                list: [
                    'Kompetente und verständliche Beratung der Eigentümergemeinschaft',
                    'Vorausschauendes Planen und Erstellen von Sanierungskonzepten und Varianten',
                    'Einfache Abwicklung mit nur einem Ansprechpartner',
                    'Hauswartungsbuch mit Inspektions- und Wartungsterminen sowie Pflegehinweisen',
                ],
            },
            {
                header: 'Für Ihre Wohnanlage:',
                list: ['Hohe Wirtschaftlichkeit', 'Langfristige Werterhaltung Ihrer Wohnanlage', 'Optimierung von Investitions- und Betriebskosten', 'Kostentransparenz'],
            },
        ],
    },
]

export default class Leistungen extends Component {
    static contextType = Context

    constructor(props) {
        super(props)
        this.state = {
            selectedItem: items[0],
        }
    }

    _renderContent() {
        if (this.state.selectedItem.data == null) return null
        return this.state.selectedItem.data.map(item => (
            <div style={{ marginLeft: 15 }}>
                <p className="list-header">{item.header}</p>
                <ul className="list-item">
                    {item.list.map(list => (
                        <li>{list}</li>
                    ))}
                </ul>
                <p>{item.sub_desc}</p>
            </div>
        ))
    }
    render() {
        return (
            <div className="main background-dark">
                <h1 className="page-title page-title-absolute text-white">Bauen im Bestand</h1>
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-3 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <p className="text-red page-sub-desc">{this.state.selectedItem.description}</p>
                                        {this._renderContent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <AnimatedMenu
                                            items={items}
                                            style={{ transform: 'scale(1.5)', zIndex: 10 }}
                                            itemClick={item => {
                                                this.setState({
                                                    selectedItem: item,
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-sm-none d-md-block h-100">
                        <AnimatedBackgroundImage class="animated-background-image" imageStyle={{ marginTop: '40%' }} image={Mouse} maxMoveX={400} maxMoveY={400} />
                    </div>
                </div>
            </div>
        )
    }
}
